import "./dropdown.css";
import Dropdown from './dropdown';
import { attachPropertiesToComponent } from '../../utils/attach-properties-to-component';
import Item from './item';
export default attachPropertiesToComponent(Dropdown, {
  Item
});